const Synstype = {
  EACH: 'each',
  PERPERSON: 'per person',
};

export default Synstype;
